var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _rect, _g11, _g12, _g13, _g14, _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _text13, _text14, _text15, _text16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBottomSideContainer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1323.5 445.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 53.006,
    y1: 95.513,
    x2: 53.006,
    y2: 402.996,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 119,
    y1: 92.507,
    x2: 119,
    y2: 399.014,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 1300.409,
    y1: 95.543,
    x2: 1300.409,
    y2: 402.904,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 9
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 52.531,
    y1: 96.029,
    x2: 1301.002,
    y2: 96.029,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 52.517,
    y1: 402.581,
    x2: 1300.988,
    y2: 402.581,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 56.014,
    y1: 5.513,
    x2: 56.014,
    y2: 92.567,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 679.666,
    y1: 31.523,
    x2: 679.666,
    y2: 92.719,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 1304,
    y1: 5.63,
    x2: 1304,
    y2: 93.468,
    fill: "#fff",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 179.972,
    y1: 105.55,
    x2: 179.972,
    y2: 111.55,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.972,
    y1: 123.705,
    x2: 179.972,
    y2: 385.029,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 179.972,
    y1: 391.107,
    x2: 179.972,
    y2: 397.107,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 299.526,
    y1: 104.351,
    x2: 299.526,
    y2: 110.351,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.526,
    y1: 122.505,
    x2: 299.526,
    y2: 383.83,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.526,
    y1: 389.908,
    x2: 299.526,
    y2: 395.908,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 431.981,
    y1: 104.714,
    x2: 431.981,
    y2: 110.714,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.981,
    y1: 122.869,
    x2: 431.981,
    y2: 384.193,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 431.981,
    y1: 390.271,
    x2: 431.981,
    y2: 396.271,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 555.609,
    y1: 104.276,
    x2: 555.609,
    y2: 110.276,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 555.609,
    y1: 122.43,
    x2: 555.609,
    y2: 383.755,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 555.609,
    y1: 389.833,
    x2: 555.609,
    y2: 395.833,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 679.496,
    y1: 105.255,
    x2: 679.496,
    y2: 111.255,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 679.496,
    y1: 123.409,
    x2: 679.496,
    y2: 384.734,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 679.496,
    y1: 390.811,
    x2: 679.496,
    y2: 396.811,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 803.788,
    y1: 105.458,
    x2: 803.788,
    y2: 111.458,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 803.788,
    y1: 123.613,
    x2: 803.788,
    y2: 384.938,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 803.788,
    y1: 391.015,
    x2: 803.788,
    y2: 397.015,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 931.649,
    y1: 105.486,
    x2: 931.649,
    y2: 111.486,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 931.649,
    y1: 123.641,
    x2: 931.649,
    y2: 384.966,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 931.649,
    y1: 391.043,
    x2: 931.649,
    y2: 397.043,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1055.63,
    y1: 105.181,
    x2: 1055.63,
    y2: 111.181,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1055.63,
    y1: 123.336,
    x2: 1055.63,
    y2: 384.661,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1055.63,
    y1: 390.738,
    x2: 1055.63,
    y2: 396.738,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1179.818,
    y1: 105.561,
    x2: 1179.818,
    y2: 111.561,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1179.818,
    y1: 123.716,
    x2: 1179.818,
    y2: 385.041,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.155 12.155",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1179.818,
    y1: 391.118,
    x2: 1179.818,
    y2: 397.118,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1296.778,
    y1: 249.801,
    x2: 1290.778,
    y2: 249.801,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1278.71,
    y1: 249.801,
    x2: 77.966,
    y2: 249.801,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 0 12.068 12.068",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 71.932,
    y1: 249.801,
    x2: 65.932,
    y2: 249.801,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 991.012,
    y: 179.178,
    width: 309.883,
    height: 132.66,
    fill: "none",
    stroke: "#000",
    strokeDasharray: "0 12",
    strokeMiterlimit: 10,
    strokeWidth: 8
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 331.513,
    y1: 41.406,
    x2: 98.291,
    y2: 41.406,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.198 26.88 53.994 41.406 108.198 55.933 108.198 26.88"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 962.659,
    y1: 22.817,
    x2: 98.322,
    y2: 22.817,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.23 8.291 54.026 22.817 108.23 37.344 108.23 8.291"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 420.857,
    y1: 43.039,
    x2: 636.462,
    y2: 43.039,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "626.555 57.565 680.759 43.039 626.555 28.512 626.555 57.565"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    x1: 1053.535,
    y1: 22.9,
    x2: 1262.107,
    y2: 22.9,
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1252.2 37.426 1306.404 22.9 1252.2 8.373 1252.2 37.426"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "translate(63.423 435.693)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Door"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1188.585 435.219)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Front"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(347.435 52.11)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20ft"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(978.343 34.87)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "40ft"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(12.229 193.137)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30,
    letterSpacing: "-.037em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "L"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(12.252 325.393)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "R"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(107.921 84.581)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(227.22 83.27)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(348.083 82.877)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(467.493 83.079)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(586.938 83.34)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(706.766 83.193)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(827.003 83.787)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(950.176 84.16)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1066.055 84.255)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9"))), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    transform: "translate(1189.857 84.565)",
    fontFamily: "ArialMT, Arial",
    fontSize: 30
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "0"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomSideContainer);
export default __webpack_public_path__ + "static/media/Bottom Side Container.ff0d7680db90cd75ec1ffc02e83ce9d2.svg";
export { ForwardRef as ReactComponent };